import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";

export default function Admin() {
  const [tab, setTab] = useState("stats");
  const [stats, setStats] = useState(null);
  const [reports, setReports] = useState([]);
  const [audit, setAudit] = useState([]);
  const [forbidden, setForbidden] = useState(false);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch((e) => { if (e?.response?.status === 403) setForbidden(true); });
    api.get("/admin/reports").then((r) => setReports(r.data)).catch(() => {});
    api.get("/admin/audit").then((r) => setAudit(r.data)).catch(() => {});
  }, []);

  if (forbidden) return <div className="flex min-h-[60vh] items-center justify-center text-sm text-[#8C8578]">Admin access required.</div>;
  if (!stats) return <div className="flex min-h-[60vh] items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-[#D4AF37]" /></div>;

  return (
    <div className="mx-auto max-w-4xl px-5 py-8" data-testid="admin-page">
      <h1 className="font-display text-3xl text-[#F4F1EA]">Admin</h1>
      <div className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-4">
        {Object.entries(stats).map(([k, v]) => (
          <div key={k} className="rounded-xl border border-[#2B241B] bg-[#12100E] p-4">
            <p className="text-2xl text-[#D4AF37]">{v}</p>
            <p className="text-xs capitalize text-[#8C8578]">{k.replace(/_/g, " ")}</p>
          </div>
        ))}
      </div>

      <div className="mt-6 flex gap-2">
        {["reports", "audit"].map((t) => (
          <button key={t} onClick={() => setTab(t)} className={`rounded-full px-4 py-2 text-sm capitalize ${tab === t ? "bg-[#24201C] text-[#D4AF37]" : "text-[#8C8578]"}`}>{t}</button>
        ))}
      </div>

      {tab === "reports" && (
        <div className="mt-4 space-y-2">
          {reports.length === 0 && <p className="text-sm text-[#8C8578]">No reports.</p>}
          {reports.map((r) => (
            <div key={r.id} className="rounded-xl border border-[#2B241B] bg-[#12100E] p-4 text-sm">
              <p className="text-[#F4F1EA]">{r.reason || "(no reason)"} · <span className="text-[#8C8578]">{r.status}</span></p>
              <p className="text-xs text-[#8C8578]">{r.kind || "ai"} · {new Date(r.at).toLocaleString()}</p>
            </div>
          ))}
        </div>
      )}
      {tab === "audit" && (
        <div className="mt-4 space-y-2">
          {audit.length === 0 && <p className="text-sm text-[#8C8578]">No admin actions yet.</p>}
          {audit.map((a) => (
            <div key={a.id} className="rounded-xl border border-[#2B241B] bg-[#12100E] p-3 text-sm">
              <span className="text-[#D4AF37]">{a.action}</span> <span className="text-[#C8C2B5]">{a.target || ""}</span>
              <span className="float-right text-xs text-[#8C8578]">{new Date(a.at).toLocaleString()}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
